import * as React from 'react';
import { cn } from '@/lib/utils';

export function Kart({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-2xl border border-slate-200 bg-white shadow-sm', className)} {...props} />;
}

export function KartBaslik({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('flex items-center justify-between border-b border-slate-100 px-5 py-4', className)} {...props} />;
}

export function KartGovde({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-5', className)} {...props} />;
}

const ROZET_RENK = {
  notr: 'bg-slate-100 text-slate-700',
  basari: 'bg-emerald-100 text-emerald-800',
  uyari: 'bg-amber-100 text-amber-800',
  hata: 'bg-red-100 text-red-800',
  bilgi: 'bg-marka-100 text-marka-700',
} as const;

export function Rozet({
  renk = 'notr',
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { renk?: keyof typeof ROZET_RENK }) {
  return (
    <span
      className={cn('inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold', ROZET_RENK[renk], className)}
      {...props}
    />
  );
}
